// extracted by mini-css-extract-plugin
export default {"container":"NotificationsHistory_container__VXmqg"};